import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../core/auth/auth.service';
import { AuthMSALService } from '../../core/auth/msal/auth-msal.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  keepSubscriptionsAlive: boolean = true;

  constructor(private readonly authService: AuthService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              private readonly authMSALService: AuthMSALService) {
  }

  ngOnInit() {
    this.authService.returnUrl = this.activatedRoute.snapshot.queryParams[ 'returnUrl' ]
      || this.authService.returnUrl;

    if (this.authService.isAuthenticated()) {
      this.router.navigate([ this.authService.returnUrl ]).then();
    }
  }

  msalLogin() {
    this.authMSALService
      .signIn()
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./client/app/features/login/login.component.ts